<template>
  <el-dialog :visible.sync='dialogVisible' :title='dialogTitle' :close-on-click-modal='false'
             @close='dialogClose' width='1400'>
    <div class='baseInfo mt10 p20'>
      <div class='operation'>
        <div class='operationTitle'>
          <div class='line' />
          <span>基础信息</span>
        </div>
      </div>
      <div class='baseInfoContent'>
        <div class='baseInfoContentItem specialItem'>
          <div class='specialOne'>
            <span class='span1'>传输类型：</span>
            <span>{{ detailData.settNo || '--' }}</span>
          </div>
          <div class='specialOne'>
            <span class='span1'>港口名称：</span>
            <span>{{ detailData.settNo || '--' }}</span>
          </div>
        </div>
        <div class='baseInfoContentItem specialItem'>
          <div class='specialOne'>
            <span class='span1'>运单编号：</span>
            <span>{{ detailData.settNo || '--' }}</span>
          </div>
          <div class='specialOne'>
            <span class='span1'>车架号：</span>
            <span>{{ detailData.settNo || '--' }}</span>
          </div>
        </div>
        <div class='baseInfoContentItem specialItem'>
          <div class='specialOne'>
            <span class='span1'>品牌：</span>
            <span>{{ detailData.settNo || '--' }}</span>
          </div>
          <div class='specialOne'>
            <span class='span1'>运输工具：</span>
            <span>{{ detailData.settNo || '--' }}</span>
          </div>
        </div>
        <div class='baseInfoContentItem specialItem'>
          <div class='specialOne'>
            <span class='span1'>备注：</span>
            <span>{{ detailData.settNo || '--' }}</span>
          </div>
          <div class='specialOne'>
            <span class='span1'>航次：</span>
            <span>{{ detailData.settNo || '--' }}</span>
          </div>
        </div>
        <div class='baseInfoContentItem specialItem'>
          <div class='specialOne'>
            <span class='span1'>航次：</span>
            <span>{{ detailData.settNo || '--' }}</span>
          </div>
          <div class='specialOne'>
            <span class='span1'>操作人：</span>
            <span>{{ detailData.settNo || '--' }}</span>
          </div>
        </div>
        <div class='baseInfoContentItem specialItem'>
          <div class='specialOne'>
            <span class='span1'>传输时间：</span>
            <span>{{ detailData.settNo || '--' }}</span>
          </div>
          <div class='specialOne'>
            <span class='span1'>传输状态：</span>
            <span>{{ detailData.settNo || '--' }}</span>
          </div>
        </div>
        <div class='baseInfoContentItem specialItem'>
          <div class='specialOne'>
            <span class='span1'>接口返回状态：</span>
            <span>{{ detailData.settNo || '--' }}</span>
          </div>
          <div class='specialOne'>
            <span class='span1'>接口返回信息：</span>
            <span>{{ detailData.settNo || '--' }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class='baseInfo'>
      <div class='operation'>
        <div class='operationTitle'>
          <div class='line ml20' />
          <span>装船列表</span>
        </div>
      </div>
      <div class='massLoss-list'>
        <div class='nav'>
          <el-form :model='searchForm' label-width='110px' :inline='true'
                   class='demo-form-inline flex1'>
            <el-form-item label='运单编号：'>
              <el-input v-model='searchForm.standingBookMonth' size='mini'
                        placeholder='请输入运单编号'></el-input>
            </el-form-item>
            <el-form-item label='车架号：'>
              <el-input v-model='searchForm.consignorName' size='mini'
                        placeholder='请输入车架号'></el-input>
            </el-form-item>

            <el-form-item>
              <el-button size='small' class='searchBtn' @click='searchBtn'>查询</el-button>
              <el-button size='small' class='resetBtn' @click='resetBtn'>重置</el-button>
            </el-form-item>
          </el-form>
        </div>
        <el-row>
          <el-col :span='24' style='text-align: end;font-size: 14px!important;'
                  class='exportButton'>
            <span @click='exportData'>导出数据</span>
          </el-col>
        </el-row>
        <div class='content'>
          <div class='tableContainer'>
            <el-table
              v-loading='tableLoading'
              :data='tableData'
              row-key='id'
              style='width: 100%'
              border
              :header-cell-style='headerCellStyle'
            >
              <el-table-column prop='standingBookMonth' label='运单编号' align='center'
                               min-width='100px' />
              <el-table-column prop='standingBookMonth' label='车架号' align='center'
                               min-width='100px' />
            </el-table>
          </div>
          <div class='paginationContainer mb20'>
            <el-pagination
              background
              :page-sizes='[10, 20, 30, 40]'
              layout='total, sizes, prev, pager, next, jumper'
              :total='total'
              @size-change='contractSizeChange'
              @current-change='contractCurrentChange'
              :current-page.sync='searchForm.page'
              :page-size='searchForm.rows'
            />
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
  import { getSummaryPageList } from '@/service/account';
  import { getSessionStore } from '@/config/mUtils';
  import { baseUrl } from '@/config/env';

  export default {
    name: 'transmissionManagementInfo',
    data() {
      return {
        dialogTitle: '详情',
        dialogVisible: false,
        detailData: { settNo: '' },
        searchForm: {
          standingBookMonth: '',
          consignorName: '',
          supplierName: '',
          submitType: 0,
          page: 1,
          rows: 10,
        },
        defaultSearchForm: {},
        tableLoading: false,
        tableData: [],
        headerCellStyle: {
          'color': '#3B3B3B',
          'font-size': '13px',
          'height': '48px',
          'background': '#E8E8E8',
        },
        total: 0,
      };
    },
    mounted() {

    },
    methods: {
      dialogClose() {
        this.dialogVisible = false;
      },
      dialogOpen(id) {
        this.defaultSearchForm = JSON.parse(JSON.stringify(this.searchForm));
        this.dialogVisible = true;
        this.searchBtn();
      },
      getType(type) {
        switch (type) {
          case 0:
            return '收入';
          case 1:
            return '公路运费';
          case 2:
            return '水路运费';
          case 3:
            return '装卸费';
          case 4:
            return '过驳费';
          case 5:
            return '提车费';
          case 6:
            return '堆存费';
          default:
            return '--';
        }
      },
      // 查询
      searchBtn() {
        this.searchForm.page = 1;
        this.getTableData();
      },
      // 重置
      resetBtn() {
        this.searchForm = JSON.parse(JSON.stringify(this.defaultSearchForm));
      },
      // 获取表格数据
      async getTableData() {
        this.tableLoading = true;
        const data = await getSummaryPageList(this.searchForm);
        this.tableLoading = false;
        this.tableData = data.data.records;
        this.total = data.data.total;
      },
      contractSizeChange(row) {
        this.searchForm.rows = row;
        this.searchForm.page = 1;
        this.getTableData();
      },
      contractCurrentChange(page) {
        this.searchForm.page = page;
        this.getTableData();
      },
      // 导出数据
      exportData() {
        // let token = getSessionStore('token');
        // window.location.href = `${baseUrl}/platform/settlement/accountCollect/countExportXls?access_token=${token}&submitType=${this.searchForm.submitType}&standingBookMonth=${this.searchForm.standingBookMonth}&consignorName=${this.searchForm.consignorName}&supplierName=${this.searchForm.supplierName}`;
        window.exportExcelGet('/platform/settlement/accountCollect/countExportXls', `submitType=${this.searchForm.submitType}&standingBookMonth=${this.searchForm.standingBookMonth}&consignorName=${this.searchForm.consignorName}&supplierName=${this.searchForm.supplierName}`)
      },
    },
  };
</script>

<style lang='scss' scoped>
  .massLoss-list {
    /*width:100%;*/
    padding: 20px 15px 0 25px;
    height: 100%;
    /*overflow: auto;*/
    .nav {
      /*width:100%;*/
      display: flex;
      /*align-items: center;*/
      /*height:30px;*/
      overflow: hidden;

      .flex1 {
        flex: 1;
      }

      .el-input {
        width: 150px;
      }

      .el-select {
        width: 150px;
      }

      ::v-deep {
        label.el-form-item__label {
          font-weight: 500;
          color: #101010;
        }
      }
    }

    ::v-deep .detail {
      .el-form-item {
        margin-bottom: 2px;

        .el-form-item__label {
          /*color: #060606;*/
          font-weight: 700;
        }
      }

      .line {
        width: 12px;
        height: 32px;
        background-color: rgba(51, 84, 131, 100);
        margin-right: 10px;
      }

      .line + span {
        font-size: 16px;
        color: rgba(51, 84, 131, 100);
        font-weight: 600;
      }

      width: 100%;
      padding: 10px 0 20px 20px;

      .baseInfo {
        display: flex;
        flex-direction: column;

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(249, 166, 6);
            margin-left: 10px;
          }
        }

        &Content {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 20px 23px 0 23px;
          font-size: 14px;

          .center-f {
            display: flex;
          }


        }
      }

      .operation {
        display: flex;
        flex-direction: column;

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }

        &Content {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 20px 23px 0 23px;
          font-size: 14px;

        }

        &Table {
          width: 100%;
          margin-top: 10px;
          padding-right: 20px;
        }
      }
    }


    ::v-deep .add {
      .el-form-item__label {
        font-weight: 700;
      }

      width: 100%;

      .baseInfo {
        display: flex;
        flex-direction: column;

        &Content {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 20px 23px 0 23px;
          font-size: 14px;

          .center-f {
            display: flex;
          }

          .yang {
            .el-form-item {
              .el-form-item__error {
                left: 40px;
              }

              margin-bottom: 5px;

              .el-form-item__label {
                // width: 150px !important;
                /*color: #060606;*/
              }

            }

          }

          .repair {
            .el-input {
              width: 80%;
            }

            .el-form-item {
              .el-form-item__error {
                /*left: 41px;*/
                padding-top: 0px;
              }

              margin-bottom: 7px;

              .el-form-item__label {
                /*width: 155px  !important;*/
                /*color: #060606;*/
              }
            }

            .el-upload-list__item {
              width: 100px;
              height: 100px;
            }

            .el-upload--picture-card {
              width: 100px;
              height: 100px;
              line-height: 100px;
            }

            /*display: none;*/
            .imgUp {
              display: flex;
              flex-direction: column;

              .imgLength {
                display: flex;
                align-items: center;
                width: 100%;

                span {
                  margin-left: auto;
                  color: rgb(183, 183, 183);
                  font-size: 16px;
                }
              }
            }
          }

        }
      }

      .btnContainer {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 13px;
        margin-top: 20px;

        button {
          margin: 0 15px;
        }
      }
    }

    ::v-deep {

      .el-dialog__header {
        padding: 9px 20px 9px;
        background: #335483;
      }

      .el-dialog__title {
        line-height: 24px;
        font-size: 14px;
        color: #FFFFFF;
      }

      .el-dialog__headerbtn {
        top: 9px;
      }

      .el-dialog__headerbtn .el-dialog__close {
        color: #fff;
        font-size: 25px;
      }

      .el-dialog__body {
        padding: 0;
        overflow: auto;
        max-height: 75vh;
        color: #606266;
      }

      .el-form--inline .el-form-item {
        margin-bottom: 5px;
      }

    }

  }

  .tableContainer {
    margin: 10px 0 30px 0;
  }

  .exportButton {
    span {
      color: rgba(51, 136, 255, 1);
      font-size: 14px;

      &:hover {
        cursor: pointer;
      }
    }
  }

  .el-dialog__wrapper {
    overflow: hidden;
  }

  .baseInfo {
    display: flex;
    flex-direction: column;

    &Title {
      display: flex;
      align-items: flex-end;

      p {
        font-weight: 700;
        font-size: 14px;
        color: rgba(51, 136, 255, 1);
        margin-left: 10px;
      }
    }

    &Content {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      padding: 20px 23px 0 23px;

      &Item {
        margin-bottom: 20px;

        .imgContainer {
          display: flex;
          align-items: center;
        }

        .span1 {
          font-weight: 700;
        }

        span {
          font-size: 14px;
        }

        .specialOne {
          width: 50%;
        }
      }

      .specialItem {
        display: flex;
      }
    }
  }

  .operation {
    display: flex;
    flex-direction: column;

    ::v-deep {
      .el-table .ui-warning-row {
        background-color: #fef0f0 !important;
      }

      .el-table--enable-row-hover .el-table__body tr.ui-warning-row:hover > td {
        background-color: #fef0f0 !important;
      }

      .el-table .ui-warning-row .cell {
        color: red;
      }
    }

    &Title {
      display: flex;
      align-items: flex-end;

      p {
        font-weight: 700;
        font-size: 14px;
        color: rgba(51, 136, 255, 1);
        margin-left: 10px;
      }
    }

    &Table {
      width: 100%;
      margin-top: 10px;
      padding: 0 20px;

      &Nav {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: flex-end;

        span {
          color: rgba(51, 136, 255, 1);
          text-decoration: underline;
          margin-right: 10px;

          &:hover {
            cursor: pointer;
          }
        }
      }
    }
  }

  .line {
    width: 12px;
    height: 32px;
    background-color: rgba(51, 84, 131, 100);
    margin-right: 10px;
  }

  .line + span {
    font-size: 16px;
    color: rgba(51, 84, 131, 100);
    font-weight: 600;
  }

  .ml20 {
    margin-left: 20px;
  }
</style>
